<script>
  export let rotate = false;
  export let fitHeight = false;
</script>

<div class="icon" class:rotate class:fitHeight>
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 5L20 10.5L13 16"
      stroke="black"
      stroke-width="1.5"
      stroke-linejoin="bevel"
    />
    <path
      d="M8 16L1 10.5L8 5"
      stroke="black"
      stroke-width="1.5"
      stroke-linejoin="bevel"
    />
    <path
      d="M13 10.5L8 10.5"
      stroke="black"
      stroke-width="1.5"
      stroke-linejoin="bevel"
    />
  </svg>
</div>

<style>
  .icon {
    display: flex;
    pointer-events: none;
    justify-content: center;
    align-items: center;
  }
  .rotate {
    rotate: 90deg;
  }
  .fitHeight {
    height: 100%;
    width: auto;
  }
  .fitHeight svg {
    width: auto;
    height: 100%;
  }
</style>
